// npm packages
import classNames from "classnames";

// components
import Text from "../Text";

const FreeInstallation = ({ children, size = "", className = "" }) => {
  return (
    <Text
      type="paragraph"
      className={classNames(
        `w-max bg-icy-landscape text-10 sm:text-14 text-coarse-wool !font-encode-sans font-medium sm:font-semibold leading-14 sm:leading-20 tracking-[0.24px] sm:tracking-[0.28px] px-4 sm:px-10 py-4 rounded-[100px] line-clamp-1 ${className}`,
        {
          // "!text-[10px] !leading-[10px] !tracking-[0.2px] !px-4": size === "sm",
        }
      )}
    >
      Free Installation
    </Text>
  );
};

export default FreeInstallation;
